import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DURATION_2, DURATION_3, EASING_FUNCTION_1, EASING_FUNCTION_2, FADE_IN, SLIDE_DOWN_IN20, SLIDE_LEFT_IN20, SLIDE_RIGHT_IN20, SLIDE_UP_IN20 } from '../../utils/animations';
import { AnimationDirection } from '../Calendar/Calendar.types';
/**
 * @internal
 */
export const calendarPickerClassNames = {
  root: 'fui-CalendarPicker',
  headerContainer: 'fui-CalendarPicker__headerContainer',
  currentItemButton: 'fui-CalendarPicker__currentItemButton',
  navigationButtonsContainer: 'fui-CalendarPicker__navigationButtonsContainer',
  navigationButton: 'fui-CalendarPicker__navigationButton',
  gridContainer: 'fui-CalendarPicker__gridContainer',
  buttonRow: 'fui-CalendarPicker__buttonRow',
  itemButton: 'fui-CalendarPicker__itemButton',
  current: 'fui-CalendarPicker__current',
  selected: 'fui-CalendarPicker__selected',
  disabled: 'fui-CalendarPicker__disabled'
};
const useRootStyles = /*#__PURE__*/__styles({
  base: {
    B7ck84d: "f1e4lqlz",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1sy4kr4",
    a9b677: "f4m2ahc"
  },
  normalize: {
    E5pizo: "f1couhl3",
    B7ck84d: "f1ewtqcl",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1s184ao",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai"
  }
}, {
  d: [".f1e4lqlz{box-sizing:content-box;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], [".f1sy4kr4{padding:12px;}", {
    p: -1
  }], ".f4m2ahc{width:196px;}", ".f1couhl3{box-shadow:none;}", ".f1ewtqcl{box-sizing:border-box;}", [".f1s184ao{margin:0;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }]]
});
const useHeaderContainerStyles = /*#__PURE__*/__styles({
  base: {
    mc9l5x: "f22iagw"
  }
}, {
  d: [".f22iagw{display:flex;}"]
});
const useCurrentItemButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f1ym3bx4",
    Bh6795r: "fqerorx",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: ["f1td8mcv", "f1udkdxo"],
    fsow6f: ["f1o700av", "fes3tcz"]
  },
  animation: {
    vin17d: "fhsqnsn",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h7u52p",
    Ezkn3b: "fjq4c94"
  },
  hasHeaderClickCallback: {
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    pugfm4: 0,
    ukgb2i: 0,
    Dwtyhm: 0,
    Biisq0s: "f15rpok4",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd",
    c3iz72: "f13c0t7h",
    mghro0: 0,
    Bx68yb: 0,
    syojd9: 0,
    E5hylx: "fy2scak"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f1ym3bx4{color:inherit;}", ".fqerorx{flex-grow:1;}", ".f1mo0ibp{font-family:inherit;}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1td8mcv{padding:0 4px 0 10px;}", {
    p: -1
  }], [".f1udkdxo{padding:0 10px 0 4px;}", {
    p: -1
  }], ".f1o700av{text-align:left;}", ".fes3tcz{text-align:right;}", ".fhsqnsn{animation-duration:0.267s;}", ".fywypte{animation-fill-mode:both;}", ".f1h7u52p{animation-name:f5j8bii;}", ".fjq4c94{animation-timing-function:cubic-bezier(.1,.25,.75,.9);}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", [".f15rpok4:hover{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}", ".f13c0t7h:hover:active{cursor:pointer;}", [".fy2scak:hover:active{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }]]
});
const useNavigationButtonsContainerStyles = /*#__PURE__*/__styles({
  base: {
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw"
  }
}, {
  d: [".f122n59{align-items:center;}", ".f22iagw{display:flex;}"]
});
const useNavigationButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f3bhgqh",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f19n0e5",
    mc9l5x: "ftgm304",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "fxldao9",
    Bg96gwp: "f336tjw",
    sshi5w: "f1ysfysz",
    Bf4jedk: "f107v6xj",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    qhf8xq: "f10pi13n",
    fsow6f: "f17mccla",
    a9b677: "f1w9dchk",
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f3sdaeg",
    eoavqd: "f8491dx",
    pugfm4: 0,
    ukgb2i: 0,
    Dwtyhm: 0,
    Biisq0s: "f15rpok4",
    iro3zm: "f1wvkgvo",
    B2d53fq: "f1wdoaqd"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", [".f3bhgqh{border:none;}", {
    p: -2
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f19n0e5{color:var(--colorNeutralForeground1);}", ".ftgm304{display:block;}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fxldao9{height:28px;}", ".f336tjw{line-height:28px;}", ".f1ysfysz{min-height:28px;}", ".f107v6xj{min-width:28px;}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".f10pi13n{position:relative;}", ".f17mccla{text-align:center;}", ".f1w9dchk{width:28px;}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f3sdaeg:hover{color:var(--colorBrandForegroundOnLightHover);}", ".f8491dx:hover{cursor:pointer;}", [".f15rpok4:hover{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}", ".f1wdoaqd:hover:active{color:var(--colorBrandForegroundOnLightPressed);}"]
});
const useGridContainerStyles = /*#__PURE__*/__styles({
  base: {
    B6of3ja: "fvjh0tl"
  }
}, {
  d: [".fvjh0tl{margin-top:4px;}"]
});
const useButtonRowStyles = /*#__PURE__*/__styles({
  base: {
    jrapky: "f15tpi3i",
    sw9gdo: "f1gdbdba"
  },
  animation: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Ezkn3b: "f1ee2ue"
  },
  horizontalBackward: {
    Bv12yb3: ["f1o9w3l8", "f1kwjajc"]
  },
  horizontalForward: {
    Bv12yb3: ["f1kwjajc", "f1o9w3l8"]
  },
  verticalBackward: {
    Bv12yb3: "fgl3yn7"
  },
  verticalForward: {
    Bv12yb3: "faiu5ye"
  }
}, {
  d: [".f15tpi3i{margin-bottom:16px;}", ".f1gdbdba:last-of-type{margin-bottom:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}", ".f1o9w3l8{animation-name:f5j8bii,f2lgmc3;}", ".f1kwjajc{animation-name:f5j8bii,fpktcv7;}", ".fgl3yn7{animation-name:f5j8bii,f3bv9km;}", ".faiu5ye{animation-name:f5j8bii,funtx0y;}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}", "@keyframes f2lgmc3{from{pointer-events:none;transform:translate3d(-20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes fpktcv7{from{pointer-events:none;transform:translate3d(20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes f3bv9km{from{pointer-events:none;transform:translate3d(0, -20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes funtx0y{from{pointer-events:none;transform:translate3d(0, 20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}"]
});
const useItemButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f3bhgqh",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f11d4kpn",
    Bahqtrf: "f1mo0ibp",
    Be2twd7: "fy9rknc",
    Bqenvij: "fbhnoac",
    Bg96gwp: "fc76cdq",
    sshi5w: "f1w5jphr",
    Bf4jedk: "f12clzc2",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: ["f1ytixos", "fqk6p8t"],
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1mk8lai",
    a9b677: "feqmc2u",
    Btgfwho: ["f65zstl", "f1yt3tqw"],
    xrote9: "flfbxit",
    Bja5ulm: "ff5vbxt",
    Jwef8y: "f18a0fwf",
    Bi91k9c: "f1u69ym5",
    eoavqd: "f8491dx",
    pugfm4: 0,
    ukgb2i: 0,
    Dwtyhm: 0,
    Biisq0s: "f15rpok4",
    Bqrx1nm: "f9ep5xw",
    ze5xyy: "f1qvjex",
    iyr2r2: "fd2qbv0",
    Bx7pl5v: 0,
    Bnosqey: 0,
    Bv57zgv: 0,
    Bbxjs3m: "fm3bo9w",
    iro3zm: "f1wvkgvo",
    g2kj27: "f1b9qfq3",
    pc6evw: "f9ddjv3",
    B76w7ga: "fr4cgi0"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", [".f3bhgqh{border:none;}", {
    p: -2
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f1mo0ibp{font-family:inherit;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fbhnoac{height:40px;}", ".fc76cdq{line-height:40px;}", ".f1w5jphr{min-height:40px;}", ".f12clzc2{min-width:40px;}", [".f1ytixos{margin:0 12px 0 0;}", {
    p: -1
  }], [".fqk6p8t{margin:0 0 0 12px;}", {
    p: -1
  }], [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], [".f1mk8lai{padding:0;}", {
    p: -1
  }], ".feqmc2u{width:40px;}", ".f65zstl:nth-child(4n + 4){margin-right:0;}", ".f1yt3tqw:nth-child(4n + 4){margin-left:0;}", ".flfbxit:nth-child(n + 9){margin-bottom:0;}", ".ff5vbxt div{font-weight:var(--fontWeightRegular);}"],
  h: [".f18a0fwf:hover{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f1u69ym5:hover{color:var(--colorNeutralForeground1Static);}", ".f8491dx:hover{cursor:pointer;}", [".f15rpok4:hover{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}"],
  m: [["@media (forced-colors: active){.f9ep5xw:hover{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1qvjex:hover{color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fd2qbv0:hover{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fm3bo9w:hover{outline:1px solid Highlight;}}", {
    p: -1,
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1b9qfq3:hover:active{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fr4cgi0:hover:active{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useCurrentStyles = /*#__PURE__*/__styles({
  highlightCurrent: {
    De3pzq: "ffp7eso",
    sj55zd: "f1phragk",
    Bhrd7zp: "fl43uef",
    Bsw6fvg: "fg374yq",
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay",
    mk428o: "ffic4m0",
    B1lrsqs: "f13lyc4l",
    z0vste: "f13g7o2i",
    Bgjd7nk: "fbbf6h8",
    kur00z: "f1fsg2me"
  }
}, {
  d: [".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f13g7o2i:hover,.f13g7o2i:hover:active{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fbbf6h8:hover,.fbbf6h8:hover:active{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1fsg2me:hover,.f1fsg2me:hover:active{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".ffic4m0:hover,.ffic4m0:hover:active{background-color:var(--colorBrandBackground);}", ".f13lyc4l:hover,.f13lyc4l:hover:active{color:var(--colorNeutralForegroundOnBrand);}"]
});
const useSelectedStyles = /*#__PURE__*/__styles({
  highlightSelected: {
    De3pzq: "f1vevd59",
    sj55zd: "ff5vbop",
    Bhrd7zp: "fl43uef",
    Bsw6fvg: "f1rirnrt",
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay",
    Bja5ulm: "fospawf",
    Jwef8y: "fbo057p",
    Bi91k9c: "f1u69ym5",
    Bqrx1nm: "fiu8gst",
    ze5xyy: "f1v4q6pl",
    iyr2r2: "fd2qbv0",
    iro3zm: "f1wvkgvo"
  }
}, {
  d: [".f1vevd59{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".ff5vbop{color:var(--colorNeutralForeground1Static);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fospawf div{font-weight:var(--fontWeightSemibold);}"],
  m: [["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fiu8gst:hover{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1v4q6pl:hover{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fd2qbv0:hover{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".fbo057p:hover{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".f1u69ym5:hover{color:var(--colorNeutralForeground1Static);}", ".f1wvkgvo:hover:active{background-color:var(--colorBrandBackgroundInvertedPressed);}"]
});
const useDisabledStyles = /*#__PURE__*/__styles({
  base: {
    Bg33ivm: "f1oelgmz",
    t69wg0: "fhh1ekj",
    Bbusuzp: "f1dcs8yz",
    ycbfsm: "fkc42ay"
  }
}, {
  d: [".f1oelgmz,.f1oelgmz:disabled,.f1oelgmz button{color:var(--colorNeutralForegroundDisabled);}", ".fhh1ekj,.fhh1ekj:disabled,.fhh1ekj button{pointer-events:none;}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
/**
 * @internal
 *
 * Apply styling to the CalendarPicker slots based on the state
 */
export const useCalendarPickerStyles_unstable = props => {
  'use no memo';

  const rootStyles = useRootStyles();
  const headerContainerStyles = useHeaderContainerStyles();
  const currentItemButtonStyles = useCurrentItemButtonStyles();
  const navigationButtonsContainerStyles = useNavigationButtonsContainerStyles();
  const navigationButtonStyles = useNavigationButtonStyles();
  const gridContainerStyles = useGridContainerStyles();
  const buttonRowStyles = useButtonRowStyles();
  const itemButtonStyles = useItemButtonStyles();
  const currentStyles = useCurrentStyles();
  const selectedStyles = useSelectedStyles();
  const disabledStyles = useDisabledStyles();
  const {
    animateBackwards,
    animationDirection,
    className,
    hasHeaderClickCallback,
    highlightCurrent,
    highlightSelected
  } = props;
  return {
    root: mergeClasses(calendarPickerClassNames.root, rootStyles.normalize, rootStyles.base, className),
    headerContainer: mergeClasses(calendarPickerClassNames.headerContainer, headerContainerStyles.base),
    currentItemButton: mergeClasses(calendarPickerClassNames.currentItemButton, currentItemButtonStyles.base, animateBackwards !== undefined && currentItemButtonStyles.animation, hasHeaderClickCallback && currentItemButtonStyles.hasHeaderClickCallback),
    navigationButtonsContainer: mergeClasses(calendarPickerClassNames.navigationButtonsContainer, navigationButtonsContainerStyles.base),
    navigationButton: mergeClasses(calendarPickerClassNames.navigationButton, navigationButtonStyles.base),
    gridContainer: mergeClasses(calendarPickerClassNames.gridContainer, gridContainerStyles.base),
    buttonRow: mergeClasses(calendarPickerClassNames.buttonRow, buttonRowStyles.base, buttonRowStyles.animation, animateBackwards !== undefined && (animationDirection === AnimationDirection.Horizontal ? animateBackwards ? buttonRowStyles.horizontalBackward : buttonRowStyles.horizontalForward : animateBackwards ? buttonRowStyles.verticalBackward : buttonRowStyles.verticalForward)),
    itemButton: mergeClasses(calendarPickerClassNames.itemButton, itemButtonStyles.base),
    selected: mergeClasses(calendarPickerClassNames.selected, highlightSelected && selectedStyles.highlightSelected),
    current: mergeClasses(calendarPickerClassNames.current, highlightCurrent && currentStyles.highlightCurrent),
    disabled: mergeClasses(calendarPickerClassNames.disabled, disabledStyles.base)
  };
};